import GlobalStore from "../store/globalStore";
import mixpanelEvents from "../../config/mixpanelEvents";
import { scrubPii } from "./piiScrubber";
import { normaliseCtaText } from "./ctaTextNormaliser";

declare var mixpanel: any;

export interface IMixpanelObjInterface {
	event: string;
	[key: string]: any;
}

let isInitialized = false;
let lastIdentifiedLeadId = "";

const ERROR_DEDUPE_WINDOW_MS = 3000;
let lastError = { key: "", at: 0 };

// The api layer and a screen can both raise error_triggered for one failure.
function isDuplicateError(data: Record<string, any>): boolean {
	const key =
		String(data.screen_name || "") +
		"|" +
		String(data.field_name || "") +
		"|" +
		String(data.error_object || data.error_message || "");
	const now = Date.now();
	if (lastError.key === key && now - lastError.at < ERROR_DEDUPE_WINDOW_MS) {
		return true;
	}
	lastError = { key, at: now };
	return false;
}

export function initMixpanelService(token: string) {
	if (isInitialized || typeof mixpanel === "undefined" || !token) return;
	try {
		mixpanel.init(token, {
			persistence: "cookie",
			cross_subdomain_cookie: true,
			secure_cookie: true,
			debug: false,
			track_pageview: false,
			autocapture: {
				click: true,
				pageview: false,
				capture_text_content: false,
				input: false,
				scroll: false,
				submit: false,
			},
			record_sessions_percent: 10,
			record_mask_text_selector: "",
			record_block_selector: "",
		});
		isInitialized = true;
	} catch (e) {
		console.error("mixpanel init failed", e);
	}
}

export default function mixpanelService(mixpanelObj: IMixpanelObjInterface) {
	try {
		if (typeof mixpanel === "undefined") return;
		const { event, ...properties } = mixpanelObj;

		if (GlobalStore.leadId && GlobalStore.leadId !== lastIdentifiedLeadId) {
			mixpanel.identify(GlobalStore.leadId);
			lastIdentifiedLeadId = GlobalStore.leadId;
		}

		const data: Record<string, any> = {
			page_name: window.location.pathname,
			...properties,
		};
		if (GlobalStore.leadId) {
			data.lead_id = GlobalStore.leadId;
		}
		if (GlobalStore.applicationID) {
			data.application_id = GlobalStore.applicationID;
		}
		if (event === mixpanelEvents.CTA_CLICKED && data.text !== undefined) {
			data.text = normaliseCtaText(data.text);
		}
		if (event === mixpanelEvents.ERROR_TRIGGERED) {
			// legacy call sites pass the raw server message
			if (data.error_object !== undefined) data.error_object = scrubPii(data.error_object);
			if (data.error_message !== undefined) data.error_message = scrubPii(data.error_message);
			if (isDuplicateError(data)) return;
		}
		mixpanel.track(event, data);
	} catch (e) {
		console.error("mixpanel track failed", mixpanelObj?.event, e);
	}
}
